import api from '../../../services/Api';
import { IAuditoriaDepreciacaoResultado } from '../interfaces/IAuditoriaDepreciacao';

export const AuditoriaDepreciacaoService = {
  async buscarResultado(params: {
    empresaId: number;
    periodo?: string;
  }): Promise<IAuditoriaDepreciacaoResultado> {
    const response = await api.get<IAuditoriaDepreciacaoResultado>('auditoria-depreciacao/resultado', {
      params: {
        empresaIds: params.empresaId,
        periodo: params.periodo || '',
      },
    });

    return (
      response.data || {
        exposicaoContabilTotal: 0,
        totalAvisos: 0,
        totalAlertas: 0,
        totalErros: 0,
        status: 'CONCILIADO',
        mensagemDirecionamento: '',
        fundamentacaoContabil: '',
        fundamentacaoTributaria: '',
        itens: [],
      }
    );
  },
};
